import { makeStyles, Theme } from '@material-ui/core/styles';
import Image from '../../assets/Patterns.png';

export const useStyles = makeStyles(
  (theme: Theme) => ({
    main: {
      display: 'flex',
      alignItems: 'center',
    },
    title: {
      fontSize: 24,
      textAlign: 'center',
      width: '290px',
      color: 'black',
      display: 'block',
      margin: '0 auto 10px',
    },
    alertmessage: {
      display: 'flex',
      borderRadius: '4px',
      margin: '0 auto',
      width: '600px',
      background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #F44336',
    },
    alertContainer: {
      display: 'flex',
      padding: '18px',
      minHeight: 'calc(100vh - 106px)',
      justifyContent: 'center',
      alignItems: 'center',
    },
    alertboxes: {
      width: '600px',
      margin: '40px',
      display: 'flex',
      flexDirection: 'column',
    },
    alertbox: {
      display: 'flex',
      padding: '8px 18px',
    },
    alertIcon: {
      marginRight: '10px',
      color: '#F44336',
    },
    alertTitle: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 600,
      color: '#621b16',
    },
    // alertbox: {
    //   display: 'flex',
    //   padding: '8px 18px',
    // },
    // alertIcon: {
    //   marginRight: '10px',
    //   color: '#F44336',
    // },
    // alertTitle: {
    //   fontSize: '16px',
    //   lineHeight: '24px',
    //   fontWeight: 600,
    //   color: '#621b16',
    // },
    alertContent: {
      marginTop: '4px',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px',
      color: '#621b16',
    },
    paper: {
      marginTop: '20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: '40px',
      width: '500px',
      boxShadow: 'none',
    },
    paperres: {
      marginTop: '8%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: '40px',
      width: 'auto',
      boxShadow: 'none',
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
    formControl: {
      marginTop: '32px',
      width: '100%',
    },
    formControlLinks: {
      marginTop: '12px',
      width: '100%',
    },
    widthFull: {
      width: '100%',
      marginTop: '10px',
    },
    marginTop: {
      marginTop: '15px',
    },
    link: {
      marginRight: theme.spacing(1),
      display: 'block',
      alignItems: 'flex-end',
      color: '#5081FF',
    },
    button: {
      width: '100%',
      boxShadow: 'none',
      textTransform: 'uppercase',
      lineHeight: '36px',
      padding: '8px 22px',
    },
    container: {
      height: '100vh',
      background: `url(${Image}), linear-gradient(180deg, #FFFFFF -30.28%, #E2E6F7 161.33%)`,
      backgroundPosition: 'center, left top',
      backgroundRepeat: 'repeat-x, repeat',
      backgroundSize: 'contain, cover',
    },

    containers: {
      height: '100vh',
      backgroundPosition: 'bottom, left top',
      backgroundRepeat: 'repeat-x, repeat',
      backgroundSize: 'contain, cover',
    },

    divider: {
      margin: `${theme.spacing(1.5)}px -${theme.spacing(2.5)}px ${theme.spacing(2.5)}px`,
    },
    forgotPassword: {
      fontWeight: 500,
      fontSize: '15px',
      lineHeight: '26px',
      display: 'flex',
      letterSpacing: '0.46px',
      color: 'rgba(0, 0, 0, 0.54)',
    },
    row: {
      alignItems: 'center',
      justifyContent: 'flex-start',
      marginBottom: theme.spacing(2),
      flexBasis: '100%',
      flexWrap: 'wrap',
    },
    titles: {
      fontSize: 20,
      textAlign: 'center',
      width: '290px',
      color: 'black',
      display: 'block',
      margin: '10px auto',
    },
    loginWithGoogleBtn: {
      transition: 'background-color 0.3s, box-shadow 0.3s',
      textTransform: 'uppercase',
      width: '100%',
      textAlign: 'center',
      padding: '12px 16px 12px 42px',
      border: 'none',
      borderRadius: '3px',
      boxShadow: '0 -1px 0 rgba(0, 0, 0, 0.04), 0 1px 1px rgba(0, 0, 0, 0.25)',
      color: '#757575',
      fontSize: '14px',
      fontWeight: 500,
      backgroundImage:
        'url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTcuNiA5LjJsLS4xLTEuOEg5djMuNGg0LjhDMTMuNiAxMiAxMyAxMiAxMyAxMy42djIuMmgzYTguOCA4LjggMCAwIDAgMi42LTYuNnoiIGZpbGw9IiM0Mjg1RjQiIGZpbGwtcnVsZT0ibm9uemVybyIvPjxwYXRoIGQ9Ik05IDE4YzIuNCAwIDQuNS0uOCA2LTIuMmwtMy0yLjJhNS40IDUuNCAwIDAgMS04LTIuOUgxVjEzYTkgOSAwIDAgMCA4IDV6IiBmaWxsPSIjMzRBODUzIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNNCAxMC43YTUuNCA1LjQgMCAwIDEgMC0zLjRWNUgxYTkgOSAwIDAgMCAwIDhsMy0yLjN6IiBmaWxsPSIjRkJCQzA1IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNOSAzLjZjMS4zIDAgMi41LjQgMy40IDEuM0wxNSAyLjNBOSA5IDAgMCAwIDEgNWwzIDIuNGE1LjQgNS40IDAgMCAxIDUtMy43eiIgZmlsbD0iI0VBNDMzNSIgZmlsbC1ydWxlPSJub256ZXJvIi8+PHBhdGggZD0iTTAgMGgxOHYxOEgweiIvPjwvZz48L3N2Zz4=)',
      backgroundColor: 'white',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '110px center',
      '&:hover': {
        boxShadow: '0 -1px 0 rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.25)',
      },
      '&:active': {
        backgroundColor: '#eeeeee',
      },
      '&:focus': {
        outline: 'none',
        boxShadow: '0 -1px 0 rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.25), 0 0 0 3px #c8dafc',
      },
      '&:disabled': {
        filter: 'grayscale(100%)',
        backgroundColor: '#ebebeb',
        boxShadow: '0 -1px 0 rgba(0, 0, 0, 0.04), 0 1px 1px rgba(0, 0, 0, 0.25)',
        cursor: 'not-allowed',
      },
      '@media (max-width: 768px)': {
        padding: '12px 16px',
        backgroundPosition: '13px center',
        textAlign: 'center',
      },
    },
    input: {
      minWidth: 250,
      flexGrow: 1,
      fontSize: 16,
      color: 'rgb(0 0 0 / 87%)',
      '& .MuiInputBase-input.Mui-disabled': {
        color: 'rgb(0 0 0 / 87%)',
      },
    },
  }),
  {
    index: 1,
  }
);
